import { useEffect } from 'react';

const DEFAULT_TITLE = 'The Warrior Tribe';
const DEFAULT_DESCRIPTION = document.querySelector('meta[name="description"]')?.content || '';

export default function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | The Warrior Tribe` : DEFAULT_TITLE;

    const tag = document.querySelector('meta[name="description"]');
    if (tag) tag.content = description || DEFAULT_DESCRIPTION;

    return () => {
      document.title = DEFAULT_TITLE;
      if (tag) tag.content = DEFAULT_DESCRIPTION;
    };
  }, [title, description]);
}
